// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--dialog-card-text-padding:0 24px}@media only screen and (max-width:701px){:root{--dialog-card-text-padding:0 16px}}.theme--light.v-counter{color:#0f172a}.theme--dark.v-counter{color:#f8fafc}.v-counter{flex:0 1 auto;font-size:12px;line-height:12px;min-height:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
